import css from '../tpl-css/style-section-card-kynorelle.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  id="card-container-unique-id"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#000000"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;"
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="false"
    data-background="#FFFFFF"
    style="background-color: transparent;"
  >
    <div class="container">
      <div class="wrap-card">
        <div
          data-attribute="card-item-content"
          data-order="1"
          data-style-center-y="false"
          class="card-left"
          style="order: 1;"
        >
          <div data-attribute="content-card" class="content-card">
            <h2><span style="color:#003566;">Everyday Comfort You Can Trust</span></h2>
            <ul>
              <li><span style="color:#6d6f74;">Stays in place, so you don't have to adjust all day</span></li>
              <li><span style="color:#6d6f74;">Soft, pressure-free comfort that moves with your body</span></li>
              <li><span style="color:#6d6f74;">Gentle on skin, breathable enough for long wear</span></li>
              <li><span style="color:#6d6f74;">Clean, minimal fit that works beyond just workouts</span></li>
            </ul>
          </div>
          <div data-show="true" data-attribute="highlight-text" class="highlight-text" style="display: block;">
            After trying Kynorelle, women noticed:
          </div>
          <div
            data-attribute="card-survay"
            data-color-percent="#003568"
            data-show-survay="true"
            class="card-survay"
            style="display: block; --color-percent: #003568;"
          >
            <div data-attribute="item-survay" class="wrap-survay-item">
              <div class="left-item">
                <svg class="size-full" viewBox="0 0 100 100">
                  <circle
                    class="text-gray-300"
                    stroke-width="8"
                    stroke="#D4DCEB"
                    fill="transparent"
                    cx="50"
                    cy="50"
                    r="40"
                  ></circle>
                  <circle
                    data-attribute="percent-circle-survay"
                    r="40"
                    cx="50"
                    cy="50"
                    stroke-width="8"
                    fill="transparent"
                    stroke="#003568"
                    stroke-linecap="butt"
                    transform="rotate(-90 50 50)"
                    stroke-dasharray="251.32741228718345"
                    stroke-dashoffset="10.053096491487347"
                  ></circle>
                </svg>
                <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #003568">
                  <span data-value="96" data-attribute="percent-survay">96</span>%
                </div>
              </div>
              <div data-attribute="description-survay" class="right-item">
                <p>
                  <span style="color:#6d6f74;"
                    ><strong>96%</strong> said they stopped adjusting their leggings constantly</span
                  >
                </p>
              </div>
            </div>

            <div data-attribute="item-survay" class="wrap-survay-item">
              <div class="left-item">
                <svg class="size-full" viewBox="0 0 100 100">
                  <circle
                    class="text-gray-300"
                    stroke-width="8"
                    stroke="#D4DCEB"
                    fill="transparent"
                    cx="50"
                    cy="50"
                    r="40"
                  ></circle>
                  <circle
                    data-attribute="percent-circle-survay"
                    r="40"
                    cx="50"
                    cy="50"
                    stroke-width="8"
                    fill="transparent"
                    stroke="#003568"
                    stroke-linecap="butt"
                    transform="rotate(-90 50 50)"
                    stroke-dasharray="251.32741228718345"
                    stroke-dashoffset="15.079644737231021"
                  ></circle>
                </svg>
                <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #003568">
                  <span data-value="94" data-attribute="percent-survay">94</span>%
                </div>
              </div>
              <div data-attribute="description-survay" class="right-item">
                <p>
                  <span style="color:#6d6f74;"
                    ><strong>94%</strong> said they felt more comfortable throughout the day</span
                  >
                </p>
              </div>
            </div>

            <div data-attribute="item-survay" class="wrap-survay-item">
              <div class="left-item">
                <svg class="size-full" viewBox="0 0 100 100">
                  <circle
                    class="text-gray-300"
                    stroke-width="8"
                    stroke="#D4DCEB"
                    fill="transparent"
                    cx="50"
                    cy="50"
                    r="40"
                  ></circle>
                  <circle
                    data-attribute="percent-circle-survay"
                    r="40"
                    cx="50"
                    cy="50"
                    stroke-width="8"
                    fill="transparent"
                    stroke="#003568"
                    stroke-linecap="butt"
                    transform="rotate(-90 50 50)"
                    stroke-dasharray="251.32741228718345"
                    stroke-dashoffset="22.619467105846503"
                  ></circle>
                </svg>
                <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #003568">
                  <span data-value="91" data-attribute="percent-survay">91</span>%
                </div>
              </div>
              <div data-attribute="description-survay" class="right-item">
                <p>
                  <span style="color:#6d6f74;"
                    ><strong>91%</strong> said they wore them for more than just workout</span
                  >
                </p>
              </div>
            </div>
          </div>

          <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
            <a
              data-attribute="card-btn"
              class="card-btn"
              href="#"
              data-radius="4"
              data-background="#003568"
              data-color="#ffffff"
              style="--color-btn: #ffffff; --background-btn: #003568; --border-radius-btn: 4px; border-radius: 4px;"
            >
              <span data-attribute="btn-text">TRY IT TODAY, RISK-FREE !</span>
              <div class="icon-btn">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L3.51 4.78636L0 9.57273H2.34L5.85 4.78636L2.34 0H0Z" fill="currentColor"></path>
                </svg>
              </div>
            </a>
            <div data-attribute="sub-btn" class="sub-btn" data-text-color=""></div>
          </div>
        </div>
        <div data-attribute="card-item-image" data-order="2" class="card-right" style="order: 2;">
          <div data-show-image="true" data-attribute="wrap-image" class="wrap-image" style="display: block;">
            <img
              data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e4de84df00f58a417933.png"
              alt=""
            />
          </div>
          <div data-show-video="false" data-attribute="wrap-video" class="wrap-video" style="display: none;">
            <video width="100%" height="auto" autoplay="" muted="" loop="" playsinline="">
              <source data-attribute="card-video" type="video/mp4" src="" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
